export const BASE_API = process.env.REACT_APP_BASE_API;
export const TOKEN_COOKIE_NAME = 'price-work';
export const REMEMBER_ME = 'price-work-remember';
